import React,{useEffect,useState} from 'react';
import './App.css';
import ChatBot from './ChatBot';
import { updateTheme } from './helper/theme';
import { liveGageDarkTheme, liveGageTheme, themeContext } from "./contexts/theme";


const App = (props)=>{


  //  useEffect(()=>{
  //   updateTheme(props.appliedTheme ?  props.appliedTheme:liveGageTheme);
 
  //  },[props.theme])
  
  // useEffect(()=>{
  //   updateTheme(props.appliedTheme)

  // },[props.appliedTheme])

 


 
      return(
        <themeContext.Provider value={props.theme}>
        <ChatBot profile={props.profile} domElement={props.domElement} isMobile={props.isMobile}  isloggedin={props.isloggedin} firstname={props.firstname} sender={props.sender} loanid={props.loanid}  loginstatus={props.loginstatus}  userid={props.userid} appliedTheme={props.appliedTheme}/>
     </themeContext.Provider>
      )
}

export default App;
